import { generateVoucherError } from './generateVoucherError';

export default generateVoucherError;
